import { Linkedin } from "lucide-react";

export const Founders = () => (
  <section data-testid="founders-section" className="container-wide py-24 md:py-32">
    <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-12">/ Core Team</p>

    {/* Founder card — text-led, consistent with co-founder */}
    <div data-testid="founder-card" className="grid grid-cols-1 lg:grid-cols-12 gap-10 border-t border-ink pt-16 mb-20">
      <div className="lg:col-span-3">
        <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-4">/ Founder</p>
        <p className="font-heading text-2xl md:text-3xl tracking-tight leading-tight mb-6">
          Dr. Padmanand <em className="font-editorial italic text-[#9F381A]">Vasanthasekaran</em>
        </p>
        <a
          href="https://in.linkedin.com/in/padmanandvasanthasekaran"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="founder-linkedin"
          className="inline-flex items-center justify-center w-9 h-9 border border-ink hover:bg-ink hover:text-white transition-colors"
          aria-label="Founder LinkedIn"
        >
          <Linkedin className="w-4 h-4" />
        </a>
      </div>
      <div className="lg:col-span-8 lg:col-start-5">
        <p className="text-sm text-gray-500 uppercase tracking-[0.2em] mb-8">Founder · Deployedd Labs</p>
        <div className="space-y-5 text-base md:text-lg text-ink-muted leading-relaxed">
          <p>
            Dr. Padmanand Vasanthasekaran brings over 15 years of experience across talent development, leadership capability building, product management, revenue growth, and industry-academia collaboration.
          </p>
          <p>
            A seasoned professional, he has a proven track record in scaling businesses, launching successful products, driving go-to-market strategies, and building strong corporate partnerships. His expertise spans strategic growth, sales pipeline development, revenue optimization, and cross-functional leadership.
          </p>
          <p>
            Having served in leadership roles including Chief Operating Officer and Assistant Director — Placements at a reputed university, he has been instrumental in creating record-breaking placement outcomes and strengthening industry engagement.
          </p>
          <p className="font-editorial italic text-xl md:text-2xl text-ink leading-snug border-l-2 border-[#9F381A] pl-6">
            "The vision behind Deployedd is rooted in a simple belief — careers should be built with intent, readiness and long-term value, not just short-term outcomes."
          </p>
        </div>
      </div>
    </div>

    {/* Co-founder card — text-led */}
    <div data-testid="cofounder-card" className="grid grid-cols-1 lg:grid-cols-12 gap-10 border-t border-ink pt-16">
      <div className="lg:col-span-3">
        <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-4">/ Co-Founder</p>
        <p className="font-heading text-2xl md:text-3xl tracking-tight leading-tight mb-6">
          Aarthy <em className="font-editorial italic text-[#9F381A]">S</em>
        </p>
        <a
          href="https://www.linkedin.com/in/aarthys11390"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cofounder-linkedin"
          className="inline-flex items-center justify-center w-9 h-9 border border-ink hover:bg-ink hover:text-white transition-colors"
          aria-label="Co-Founder LinkedIn"
        >
          <Linkedin className="w-4 h-4" />
        </a>
      </div>
      <div className="lg:col-span-8 lg:col-start-5">
        <p className="text-sm text-gray-500 uppercase tracking-[0.2em] mb-8">Co-Founder · Deployedd Labs</p>
        <div className="space-y-5 text-base md:text-lg text-ink-muted leading-relaxed">
          <p>
            Aarthy S is a Learning &amp; Development professional with a strong interest in research and capability building.
          </p>
          <p>
            At Deployedd Labs, she leads initiatives across industry-integrated learning, talent acceleration, and structured training programs — working closely with colleges, corporates and leadership teams.
          </p>
          <p>
            Her approach combines structured learning, innovation-led execution, and measurable impact — enabling individuals and organizations to grow with clarity and purpose.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Founders;
